import PrimaryButton from '../buttons/PrimaryButton'
import React from 'react'
import CheckDone from '../icons/CheckDone'
import {
  convertTimeToText,
  getFirstUnearnedBadge,
  getProgressStage,
  getStageStatus, isEarnedStage,
} from '../../utils/helpers'
import OutlineButton from '../buttons/OutlineButton'

const Stage = ({ stage, handleBadgeComplete }) => {
  const renderStatus = () => {
    const time = convertTimeToText(stage.time_to_complete)
    const process = getProgressStage(stage)
    const isEarned = isEarnedStage(stage)
    const disabled = getStageStatus(stage) !== 'in_progress'
    const stageBadgeIds = stage.stage_badges.map((stageBadge) => stageBadge.id)
    const thinkificLink = stage.thinkific_link || undefined
    const renderBadgeImage = (badges, isEarned) => {
      if (badges && badges.length > 0) {
        return badges.map((badge, index) => (
          <div className="w-16 p-2 rounded border border-[#B3B2B2]">
            <img
              key={index}
              src={badge.image_url}
              className={`${!isEarned && 'opacity-50 grayscale'}`}
              alt="rocket"
            />
          </div>
        ))
      }

      return (
        <div className="w-16 p-2 rounded border border-[#B3B2B2]">
          <img
            src="/images/course_default.png"
            className={`${!isEarned && 'opacity-50 grayscale'}`}
            alt="rocket"
          />
        </div>
      )
    }

    const renderBadgeName = (badges) => {
      if (badges && badges.length > 0) {
        return badges[0].name
      }

      return ''
    }

    switch (true) {
      case process === 0:
      default:
        return (
          <div className="flex-1 bg-white h-full p-4 flex flex-row justify-between gap-4 border border-grey-400 rounded-lg">
            <div className="w-full flex flex-col gap-4 justify-start">
              <a className="text-base text-black">
                {stage.description} ({time})
              </a>
              <PrimaryButton
                disabled={disabled}
                onClick={() => handleBadgeComplete(stageBadgeIds, 100, thinkificLink)}
                className="w-40 h-10"
              >
                Start
              </PrimaryButton>
            </div>
            <div className="w-48 flex flex-col gap-2 justify-center items-center">
              <div className="flex gap-2">
                {renderBadgeImage(stage.badges, isEarned)}
              </div>
              <p className="text-xs">{renderBadgeName(stage.badges)}</p>
            </div>
          </div>
        )
      case process > 0 && process < 100:
        return (
          <div className="flex-1 bg-white h-full p-4 flex flex-row justify-between gap-4 border border-grey-500 rounded-lg">
            <div className="w-full flex flex-col gap-4 justify-start">
              <a className="text-base text-black">
                {stage.description} ({time})
              </a>
              <OutlineButton
                disabled={disabled}
                onClick={() => handleBadgeComplete(stageBadgeIds, 100, thinkificLink)}
                className="w-40 h-10"
              >
                Continue
              </OutlineButton>
            </div>
            <div className="min-w-40">
              <div className="w-48 flex flex-col gap-2 justify-center items-center">
                <a className="text-sm text-black">{time}</a>
                <div className="flex gap-2">
                  {renderBadgeImage(stage.badges, isEarned)}
                </div>
                <p className="text-xs">{renderBadgeName(stage.badges)}</p>
              </div>
            </div>
          </div>
        )
      case process === 100:
        return (
          <div className="flex-1 bg-white h-full p-4 flex flex-row justify-between items-center gap-4 border border-grey-500 rounded-lg">
            <div className="w-full text-base text-black flex flex-col gap-4">
              <p>{stage.description} ({time})</p>
              <OutlineButton
                href={stage.thinkific_link}
                className="w-48 h-10"
              >
                Go back to course
              </OutlineButton>
            </div>
            <div className="flex gap-2 w-fit">
              <div className="flex flex-col gap-2 justify-center items-center">
                <CheckDone color="#26BE74" size="10" />
                <p className="text-[#26BE74] text-sm">Completed</p>
              </div>
              <div className="flex gap-2">
                {renderBadgeImage(stage.badges, isEarned)}
              </div>
            </div>
          </div>
        )
    }
  }

  return (
    <div>
      <p className="cursor-pointer text-lg inline-block font-bold rounded-t-lg text-black mb-3">
        {stage.name}
      </p>
      <div className="flex justify-center items-center w-full rounded-lg overflow-hidden">
        {renderStatus()}
      </div>
    </div>
  )
}

export default Stage
